class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}
customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.sneakerModels = this.querySelectorAll('li[data-model]');
    this.sneakerModelsLinks = this.querySelectorAll('ul.models');

    this.headerImages = this.querySelectorAll('.mega-menu__image');

    //console.log('MODELS', this.sneakerModels);
    //console.log('MODELS_LINK', this.sneakerModelsLinks);

    this.sneakerModelsLinks.forEach((modelLink) =>
      modelLink.addEventListener('mouseover', (event) => {
        if (!event.target.dataset.model) return;
        console.log('LOL', event.target.dataset.model);
        let sneakerImage = Array.from(this.sneakerModels).find((li) => li.dataset.model === event.target.dataset.model);

        this.sneakerModels.forEach((model) => model.classList.add('hidden'));
        this.headerImages.forEach((image) => image.classList.add('hidden'));
        sneakerImage.classList.remove('hidden');
      })
    );

    this.sneakerModelsLinks.forEach((modelLink) =>
      modelLink.addEventListener('mouseleave', (event) => {
        console.log('LEAVE');
        console.log('this.sneakerModels', this.sneakerModels);

        this.headerImages.forEach((image) => image.classList.remove('hidden'));
        this.sneakerModels.forEach((model) => model.classList.add('hidden'));
      })
    );
  }

  close() {
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.querySelector('header')) document.querySelector('header').toggleAttribute('open');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
